import {
    useUserStore,
    useTariffStore,
    useSettingsStore,
    mapSettingsFromServer,
    mapIntegrationsStatusesFromServer,
    useIntegrationsStore,
} from "@/entities";
import { isArray, isNil } from "@/shared";
import { useSidebarStore } from "@/widgets";

import { getWorkspaceIntegrations } from "../api/getWorkspaceIntegrations.js";
import { getWorkspaceSettings } from "../api/getWorkspaceSettings.js";

export const initWorkspace = async function () {
    const workspaceSettings = await getWorkspaceSettings();

    const userStore = useUserStore();
    const tariffStore = useTariffStore();
    const sidebarStore = useSidebarStore();
    const settingsStore = useSettingsStore();
    const integrationsStore = useIntegrationsStore();

    if (isNil(workspaceSettings)) return;

    if (!isNil(workspaceSettings.profile)) {
        useUserStore().setHumanId(workspaceSettings.profile.id);
    }

    if (!isNil(workspaceSettings.profile_id)) {
        userStore.setProfileId(workspaceSettings.profile_id);
    }

    if (!isNil(workspaceSettings.role)) {
        if (workspaceSettings.role.is_admin) {
            location.replace(`https://${import.meta.env.VITE_APP_ADMIN}`);
        }

        userStore.setIsDirector(workspaceSettings.role.is_director);
    }

    if (!isNil(workspaceSettings.user)) {
        userStore.setUserCredentials(workspaceSettings.user);
    }

    if (isArray(workspaceSettings.menu)) {
        sidebarStore.setMenuLinks(workspaceSettings.menu);
    }

    if (!isNil(workspaceSettings.settings)) {
        settingsStore.setSettings(
            mapSettingsFromServer(workspaceSettings.settings)
        );
    }

    /* if (!isNil(workspaceSettings.tariff)) {
        useTariffStore().setTariff(
            mapHumanTariffFromServer(workspaceSettings.tariff)
        );
    } */

    /* if (!isNil(workspaceSettings.statistics)) {
        useTariffStore().setStatistic(
            mapTariffStatisticFromServer(workspaceSettings.statistics)
        );
    } */

    // USE-2742: integrations теперь приходят отдельным lazy-запросом и не блокируют
    // загрузку кабинета. Если backend ещё отдаёт integrations в init payload
    // (старая версия) — используем их как fast-path. Иначе дёргаем lazy.
    if (!isNil(workspaceSettings.integrations)) {
        integrationsStore.setIntegrations(
            mapIntegrationsStatusesFromServer(workspaceSettings.integrations)
        );
    } else {
        // Не await — пусть кабинет рендерится сразу. Иконки/статусы интеграций
        // подгрузятся через 2-3 сек когда вернётся ответ. Ошибка не критична —
        // integrationsStore имеет дефолтные значения и UI работает.
        getWorkspaceIntegrations()
            .then((integrations) => {
                if (!isNil(integrations)) {
                    integrationsStore.setIntegrations(
                        mapIntegrationsStatusesFromServer(integrations)
                    );
                }
            })
            .catch((err) => {
                // eslint-disable-next-line no-console
                console.warn("lazy integrations load failed:", err);
            });
    }

    if (!isNil(workspaceSettings.token)) {
        settingsStore.setToken(workspaceSettings.token);
    }

    // setTariff и loadRights не зависят друг от друга — параллельный запуск
    // экономит 1 round-trip для employee (для директора loadRights — sync no-op
    // без API call), USE-2742.
    await Promise.all([tariffStore.setTariff(), userStore.loadRights()]);
};
